// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"43":"457fae5e","213":"7d41a3d8","234":"b6e37534","239":"a0a35bce","455":"dc43c0df","653":"a444cfd3","844":"ffdd65cd"}[chunkId] + ".chunk.js";
};